module.exports = __webpack_public_path__ + "img/ggtb.523a5f5c.png";